import { NgModule } from '@angular/core';
import { DateTimeFilterFormatPipe } from './datetime-filter-format-pipe';

@NgModule({
   declarations: [DateTimeFilterFormatPipe],
   exports: [DateTimeFilterFormatPipe],
})
export class DateTimeFilterFormatPipeModule {}
